import { Fragment, useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { MessageLayoutWrapper } from '../MessageMenu';
import { Stack } from 'components/Stack';

import ManualTable from './ManualTable';
import ManualMessage from './ManualMessage';
import MessagePromptModal from '../common/MessagePromptModal';
import { OptionalFilterList } from './ManualTable';
import { useIsDifferenceStore } from '../common/MessagePromptStore';
import { useCheckedCustomerInfos } from './ManualStore';
import { useTransferRecipent } from '../History/HistoryStore';

export type TRequestFilter = {
  orderStatus: string;
  startDate: string;
  endDate: string;
  searchItem?: string;
  keyword?: string;
};

const MessageManual = () => {
  const { isDifference, setIsDifference } = useIsDifferenceStore();
  const { checkedCustomerInfos, setCheckedCustomerInfos } = useCheckedCustomerInfos();
  const { setTransferRecipent } = useTransferRecipent();

  const [requestFilter, setRequestFilter] = useState<TRequestFilter>({
    orderStatus: 'all',
    startDate: dayjs().subtract(6, 'day').format('YYYY-MM-DD'),
    endDate: dayjs().format('YYYY-MM-DD'),
    // searchItem: OptionalFilterList[0].value,
    // keyword: '',
  });

  // 페이지 벗어날 때 초기화
  useEffect(() => {
    return () => {
      // 조회조건 초기화
      setRequestFilter({
        orderStatus: 'all',
        startDate: dayjs().subtract(6, 'day').format('YYYY-MM-DD'),
        endDate: dayjs().format('YYYY-MM-DD'),
        // searchItem: OptionalFilterList[0].value,
        // keyword: '',
      });
      // 임시작성 취소 처리 초기화
      setIsDifference(false);
      // 체크된 고객정보 초기화
      setCheckedCustomerInfos([]);
      // 페이지 벗어날 때 transferRecipent 초기화
      setTransferRecipent(null);
    };
  }, []);

  return (
    <>
      <MessageLayoutWrapper useVerticalScroll>
        <Stack style={{ width: '60%', minWidth: 900 }}>
          <ManualTable requestFilter={requestFilter} setRequestFilter={setRequestFilter} />
        </Stack>
        <Stack style={{ width: '40%', minWidth: 649, borderLeft: '2px solid rgb(216, 221, 234)' }}>
          <ManualMessage requestFilter={requestFilter} />
        </Stack>
      </MessageLayoutWrapper>
      <MessagePromptModal />
    </>
  );
};

export default MessageManual;
